import avatar from './avatar.svg'
import buy_dark from './buy_dark.svg'
import buy_light from './buy_light.svg'
import fast_dark from './fast_dark.svg'
import fast_light from './fast_light.svg'
import monkey from './monkey.svg'
import move_dark from './move_dark.svg'
import move_light from './move_light.svg'
import stop from './stop.svg'
import short_dark from './short_dark.svg'
import short_light from './short_light.svg'
import stop_deal from './stop_deal.svg'

export const images = { avatar, buy_dark, buy_light, fast_dark, fast_light, monkey, move_dark, move_light, stop, short_dark, short_light, stop_deal };
